// extracted by mini-css-extract-plugin
module.exports = {"switch":"Toggle_switch__iC0KA","sliderRound":"Toggle_sliderRound__MdEHi","label":"Toggle_label__3DQvW"};